import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import DataTable, { TableStyles } from 'react-data-table-component';
import moment from 'moment';
import { addPendingMalerialsToCart, getAllProposeMaterialOrdersWithPagination, getCartInvoiceByFranchise } from '@app/services/order';
import UpdateConsolidatedOrderStatusModal from './UpdateConsolidatedOrderStatusModal';
import { Button } from '@app/components';
import { confirmAlert } from 'react-confirm-alert';
import { setStep } from '@app/store/reducers/order';

const ProposedMaterialOrders = () => {

    const orderStore = useSelector((state: any) => state.order);
    const [records, setRecords] = useState([]);
    const [isLoading, setLoading] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams()
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(searchParams.get('perPage') ?? 10);
    const [currentPage, setCurrentPage] = useState(searchParams.get('page') ?? 1);
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [updateStatusPayload, setUpdateStatusPayload] = useState({});
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const customStyle: TableStyles = {
        head: {
            style: {
                color: "#5E5873",
                fontSize: "13px",
                fontWeight: 900,
            },
        },
        headCells: {
            style: {
                borderColor: "#E9ECEF",
                textTransform: "uppercase",
                letterSpacing: "1px",
            },
        },
        headRow: {
            style: {
                backgroundColor: "#F7F7F8",
                minHeight: "44px",
                fontWeight: 500,
            },
        },
    };
    
    useEffect(() => {
        searchParams.set('franchiseId', orderStore?.franchise?.id)
        searchParams.set('isGroupFranchise', orderStore?.franchise?.is_group_franchise)
        searchParams.set('groupId', orderStore?.franchise?.group_id)
        setSearchParams(searchParams)
    },[]);

    useEffect(() => {
        if(orderStore?.franchise == null){
            dispatch(setStep(1))
            navigate('/orders/place')
        }else{
            getAllProposeMaterialOrders()
        }
    },[searchParams]);

    const getAllProposeMaterialOrders = async () => {
        try {
            setLoading(true);
            const resp = await getAllProposeMaterialOrdersWithPagination(searchParams)
            if (resp.success === true) {
                setLoading(false);
                setRecords(resp?.collections?.data);
                setTotalRows(resp?.collections?.pagination?.total);
            } else {
                setLoading(false);
                toast.error(resp?.errors[0]?.msg);
            }
        } catch (error: any) {
            setLoading(false);
            toast.error(error?.message || 'Internal Server Error')
        }
    };

    const getCartInvoiceDataByFranchise = async (e) => {
        try {
            setLoading(true);
            const resp = await getCartInvoiceByFranchise(orderStore?.franchise?.id);
            if (resp?.success === true) {
                setLoading(false);
                if(resp?.collections?.materials_in_cart){
                    confirm(e, 'Add to Cart!', 'Your cart already has some items!', [
                            {
                                label: 'Update Cart',
                                onClick: () => addPendingMalerialsToCartAPI({
                                    franchise_id: orderStore?.franchise?.id,
                                    is_group_franchise: orderStore?.franchise?.is_group_franchise,
                                    group_id: orderStore?.franchise?. group_id,
                                    flag: 'update'
                                })
                            },
                            {
                                label: 'Clear Cart and Add',
                                onClick: () => addPendingMalerialsToCartAPI({
                                    franchise_id: orderStore?.franchise?.id,
                                    is_group_franchise: orderStore?.franchise?.is_group_franchise,
                                    group_id: orderStore?.franchise?. group_id,
                                    flag: 'new'
                                })
                            }
                        ])
                }else{
                    confirm(e, 'Add to Cart!', 'Please confirm before proceeding.', [
                            {
                                label: 'Add to Cart',
                                onClick: () => addPendingMalerialsToCartAPI({
                                    franchise_id: orderStore?.franchise?.id,
                                    is_group_franchise: orderStore?.franchise?.is_group_franchise,
                                    group_id: orderStore?.franchise?. group_id,
                                    flag: 'new'
                                })
                            },
                            {
                                label: 'Cancel',
                                onClick: () => {}
                            }
                        ])
                }
            } else {
                setLoading(false);
                toast.error(resp?.errors[0]?.msg);
            }
        } catch (error: any) {
            setLoading(false);
            toast.error(error?.message || 'Internal Server Error');
        }
    };

    const viewCart = async (e) => {
        try {
            setLoading(true);
            const resp = await getCartInvoiceByFranchise(orderStore?.franchise?.id);
            if (resp?.success === true) {
                setLoading(false);
                if(resp?.collections?.materials_in_cart){
                    dispatch(setStep(2))
				    navigate('/orders/place/')
                }else{
                    toast.warning('Your cart is empty');
                }
            } else {
                setLoading(false);
                toast.error(resp?.errors[0]?.msg);
            }
        } catch (error: any) {
            setLoading(false);
            toast.error(error?.message || 'Internal Server Error');
        }
    };

    const confirm = (e, title, message, buttons) => {
        confirmAlert({
            title: title,
            message: message,
            buttons: buttons
        });
        e.preventDefault();
    };

    const addPendingMalerialsToCartAPI = async (payload) => {
        try {
            setLoading(true);
            const resp = await addPendingMalerialsToCart(payload);
            if(resp.success === true){
                setLoading(false)
                toast.success(resp?.message)
                dispatch(setStep(2))
				navigate('/orders/place/')
                // getAllProposeMaterialOrders()
            }else{
                toast.error(resp?.errors[0]?.msg);
                setLoading(false);
            }
        } catch (error: any) {
            setLoading(false);
            toast.error(error?.message || 'Internal Server Error')
        }
    };
    
    const columns = [
        {
            name: 'Franchise',
            selector: (row: { franchise_name: string; }) => row.franchise_name ? row.franchise_name : '---',
            sortable: true,
            sortField: 'franchise_name',
            wrap: true,
        },
        {
            name: 'Centre',
            selector: (row: { centre_name: string; }) => row.centre_name ? row.centre_name : '---',
            sortable: true,
            sortField: 'centre_name',
            wrap: true,
        },
        {
            name: 'Student',
            selector: (row: {student_name: string;}) => row.student_name,
            sortable: true,
            sortField: 'student_name',
            wrap: true,
        },
        {
            name: 'Subject',
            selector: (row: { subject_name: string; }) => row.subject_name == 'mix_match' ? 'Mix and Match' : row.subject_name,
            sortable: true,
            sortField: 'subject_name',
        },
        {
            name: 'Status',
            selector: (row: { status_label: string; }) => row.status_label,
            cell: (row: { status: string, status_label: string; }) => (
                row.status === 'added_to_cart' ? <span className="uppercase badge bg-success">{ row?.status_label }</span> : (row.status === 'pending' ? <span className="uppercase badge bg-warning">{ row?.status_label }</span> : <span className="uppercase badge bg-danger">{row?.status_label}</span>)
            ),
            sortable: true,
            sortField: 'status',
        },
        {
            name: 'Created On',
            selector: (row: { created_at: string; }) => row.created_at,
            cell: (row: { created_at: string; }) => (
                row.created_at ? moment(row.created_at).format('DD/MM/YYYY') : '---'
            ),
            sortable: true,
            sortField: 'created_at',
        },
        {  
            name: 'Action',
            cell: (row: { id: number}) => (
              <>
                <a href='#' onClick={ (e) => handleUpdateStatus(e, row)}>
                    <i className="fas fa-pen mr-2" title="Update Status"></i>
                </a>
                <Link
                    to={`${row.id}/details`}
                    role="button"
                    state={{ id: row.id }}
                    data-toggle="tooltip" title="View Details"
                    >
                    <i className="fas fa-eye mr-2"/>
                </Link>
              </>
            ),
        },
    ];

    const conditionalRowStyles = [
        {
            when: row => row.viewed === true,
            style: {
                backgroundColor: 'rgb(222, 250, 216)',
                // color: 'white',
            },
        }
    ];

    const handlePageChange = page => {
        searchParams.set('page', page)
        setSearchParams(searchParams)
        
        setCurrentPage(page);
    };

    const handlePerRowsChange = async (newPerPage, page) => {
        searchParams.set('perPage', newPerPage)
        setSearchParams(searchParams)
        
        setPerPage(newPerPage);
    };

    const handleSort = async (column, sortDirection) => {
        searchParams.set('sortField', column.sortField)
        searchParams.set('sortDirection', sortDirection)
        setSearchParams(searchParams)
    };

    const handleUpdateStatus = async(e, row) => {
        e.preventDefault()
        handleShow()
        setUpdateStatusPayload(row)
    }

    const handleBack = () => {
        dispatch(setStep(1))
        navigate('/orders/place/')
    }

    return (
        <div>
            {/* Content Header (Page header) */}
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1>Proposed Material Orders</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><a href="/">Home</a></li>
                                <li className="breadcrumb-item active">Proposed Material Orders</li>
                            </ol>
                        </div>
                    </div>
                </div>{/* /.container-fluid */}
            </section>
            {/* Main content */}
            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div style={{ marginBottom: 10 }} className="row">
                                
                            </div>
                            <div className="card">
                                <div className="card-header">
                                    <h3 className="card-title">Proposed Material Orders</h3>
                                    <div className="col-lg-12 text-right">
                                        <Button type="button" onClick={ handleBack } className="btn btn-default mr-2"> Back </Button>
                                        <Button className="btn btn-primary mr-2" isLoading={isLoading} onClick={ (e) => viewCart(e)} ><i className="fas fa-shopping-cart"></i> View Cart </Button>
                                        { records.length > 0 && (
                                            <Button className="btn btn-primary mr-2" isLoading={isLoading} onClick={ (e) => getCartInvoiceDataByFranchise(e)} ><i className="fas fa-plus"></i> Add Pending Materials To Cart </Button>
                                        )}
                                    </div>
                                </div>
                                {/* /.card-header */}
                                <div className="card-body">
                                    <DataTable
                                        keyField='proposed-material-orders'
                                        columns={columns}
                                        data={records}
                                        pagination
                                        paginationServer
                                        paginationTotalRows={totalRows}
                                        paginationDefaultPage={Number(currentPage)}
                                        onChangePage={handlePageChange}
                                        onChangeRowsPerPage={handlePerRowsChange}
                                        paginationPerPage={Number(perPage)}
                                        paginationRowsPerPageOptions={[5, 10, 20, 30, 50, 100]}
                                        progressPending={isLoading}
                                        sortServer
                                        onSort={handleSort}
                                        customStyles={customStyle}
                                        conditionalRowStyles={conditionalRowStyles}
                                    />
                                </div>
                                {/* /.card-body */}
                            </div>
                        </div>
                        {/* /.col */}
                    </div>
                    {/* /.row */}
                </div>
                {/* /.container-fluid */}
                <UpdateConsolidatedOrderStatusModal
                    show={show}
                    handleClose={handleClose}
                    getAllProposeMaterialOrders={getAllProposeMaterialOrders}
                    payload={updateStatusPayload}
                />
            </section>
            {/* /.content */}
        </div>
    )
};

export default ProposedMaterialOrders;